import { AddTask, CardTravel, CurrencyBitcoin } from '@mui/icons-material';
import BusinessIcon from '@mui/icons-material/Business';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { Collapse } from '@mui/material';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const SPACING = {
  XS: 1,
  SM: 2,
  MD: 3,
  LG: 4,
};

const NAV_ITEMS = [
  { label: 'Companies', to: '/companies', Icon: BusinessIcon },
  { label: 'Tokens', to: '/tokens', Icon: CurrencyBitcoin },
  { label: 'Wallets', to: '/wallets', Icon: CardTravel },
];

export default function LeftMenu({
  portfolios,
  setAddPortfolioDialogOpen,
  onNavigate = () => {},
}) {
  const { pathname } = useLocation();
  const [portfoliosOpen, setPortfoliosOpen] = useState(true);

  return (
    <List component="nav" sx={{ minWidth: 240 }}>
      {NAV_ITEMS.map(({ label, to, Icon }) => (
        <ListItemButton
          key={to}
          component={Link}
          to={to}
          selected={pathname === to}
          onClick={onNavigate}
        >
          <ListItemIcon>
            <Icon />
          </ListItemIcon>
          <ListItemText primary={label} />
        </ListItemButton>
      ))}
      <ListItemButton onClick={() => setPortfoliosOpen((prev) => !prev)}>
        <ListItemIcon>
          <ListAltIcon />
        </ListItemIcon>
        <ListItemText primary="Portfolios" />
        {portfoliosOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={portfoliosOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {portfolios.map((portfolio) => (
            <ListItemButton
              key={portfolio.id}
              sx={{ pl: SPACING.MD }}
              component={Link}
              to={`/portfolios/${portfolio.id}`}
              selected={pathname === `/portfolios/${portfolio.id}`}
              onClick={onNavigate}
            >
              <ListItemIcon>
                <CardTravel />
              </ListItemIcon>
              <ListItemText primary={portfolio.name} />
            </ListItemButton>
          ))}
          <ListItemButton
            key="addPortfolio"
            sx={{ pl: SPACING.MD }}
            onClick={() => {
              setAddPortfolioDialogOpen(true);
              onNavigate();
            }}
          >
            <ListItemIcon>
              <AddTask />
            </ListItemIcon>
            <ListItemText primary="New" />
          </ListItemButton>
        </List>
      </Collapse>
    </List>
  );
}
